module.exports = __webpack_public_path__ + "static/media/duplicate.f558529b.svg";